import { useSetAtom } from 'jotai'
import { transcriptAtom, isListeningAtom } from 'atoms'

export const useSpeechRecognition = () => {
  const setTranscript = useSetAtom(transcriptAtom)
  const setIsListening = useSetAtom(isListeningAtom)

  const startListening = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition

    if (SpeechRecognition) {
      const recognition = new SpeechRecognition()
      recognition.continuous = false
      recognition.interimResults = false

      recognition.onresult = (event) => {
        const spokenText = event.results[0][0].transcript
        setTranscript(spokenText)
        setIsListening(false)
      }

      recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error)
        setIsListening(false)
      }

      recognition.onend = () => {
        setIsListening(false)
      }

      setIsListening(true)
      recognition.start()
    }
  }

  return { startListening }
}
